import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EventCard } from './event-card';
import { CardGrid } from './section';
import { TOURS_PAGE_SIZE } from './tour-grid';
import type { DbEvent } from '@todo/core/supabase';

// The tour grid's "Show more" row, the same look.
import css from './tour-grid.module.css';

// A list page's event cards, a page at a time — TourGrid for shows: the whole
// list is already on the page, so "Show more" only reveals the next cards. A
// new list (a filter) starts again from the first page.
export function EventGrid({ events }: { events: DbEvent[] }) {
  const { t } = useTranslation();
  const [shown, setShown] = useState(TOURS_PAGE_SIZE);

  useEffect(() => setShown(TOURS_PAGE_SIZE), [events]);

  const rest = events.length - shown;
  return (
    <>
      <CardGrid>
        {events.slice(0, shown).map((event) => (
          <EventCard key={event.show_slug} event={event} />
        ))}
      </CardGrid>
      {rest > 0 ? (
        <div className={css.moreRow}>
          <button type="button" className={css.moreButton} onClick={() => setShown((n) => n + TOURS_PAGE_SIZE)}>
            {t('tours.showMore', { count: Math.min(rest, TOURS_PAGE_SIZE) })}
          </button>
        </div>
      ) : null}
    </>
  );
}
